import { useEffect, useRef, useState } from 'react';

export function useSlideIn(options) {
  var ref = useRef(null);
  var stateArr = useState(false);
  var isVisible = stateArr[0];
  var setIsVisible = stateArr[1];
  
  // Extract primitive values from options to use as stable dependencies
  var threshold = options && options.threshold !== undefined ? options.threshold : 0.15;
  var rootMargin = options && options.rootMargin !== undefined ? options.rootMargin : '0px';

  useEffect(function() {
    var node = ref.current;
    if (!node) return;
    
    var localSetVisible = setIsVisible;
    
    var observer = new IntersectionObserver(function(entries) {
      var entry = entries[0];
      if (entry && entry.isIntersecting) {
        localSetVisible(true);
        observer.unobserve(entry.target);
      }
    }, {
      threshold: threshold,
      rootMargin: rootMargin
    });
    
    observer.observe(node);
    
    return function() { 
      observer.disconnect(); 
    };
  }, [threshold, rootMargin, setIsVisible]);

  return { ref: ref, isVisible: isVisible };
}
